import { axiosRequest } from '@/plugins/axios-common'

import { handleError } from '@/store/handle-error'

import { AccountRecoveryActions } from './partials/account-recovery'
import { AccountVerificationActions } from './partials/account-verification'
import { GlobalViewActions } from './partials/global_view'
import { UserGroupActions } from './partials/user_groups'
import { UserLoginHistoryActions } from './partials/login-history'
import { UserNewsActions } from './partials/news'
import { UserPermissionsActions } from './partials/permissions'
import { UserProfileActions } from './partials/user-profile'
import { UserRolesActions } from './partials/roles'
import { UserSessionsActions } from './partials/sessions'
import { UserTeamsActions } from './partials/teams'

export const UserActions = {
  ...AccountRecoveryActions,
  ...AccountVerificationActions,
  ...GlobalViewActions,
  ...UserGroupActions,
  ...UserLoginHistoryActions,
  ...UserNewsActions,
  ...UserPermissionsActions,
  ...UserProfileActions,
  ...UserRolesActions,
  ...UserSessionsActions,
  ...UserTeamsActions,

  getUser (_, userId) {
    return axiosRequest.get(`/users/${userId}`).
      then(({ data }) => data.user).
      catch(handleError)
  },

  requestUserEmailAddressVerification: async (_, { emailAddressId, userId }) => {
    return axiosRequest.
      post(`/users/${userId}/emails/${emailAddressId}/verify`).
      then(({ data }) => data).
      catch(handleError)
  },

  clearUserTOTPConfiguration: async ({ commit }, { userId }) => {
    return axiosRequest.
      delete(`/users/${userId}/totp`).
      then(({ data }) => {
        commit('setUserProfile', data.user)
      }).
      catch(handleError)
  },

  generateUserTOTPConfiguration: async (_, { userId }) => {
    return axiosRequest.
      get(`/users/${userId}/totp`).
      then(({ data }) => data).
      catch(handleError)
  },

  confirmUserTOTPConfiguration: async ({ commit }, { userId, secret, passcode }) => {
    return axiosRequest.
      post(`/users/${userId}/totp`, {
        totp: {
          passcode,
          secret,
        },
      }).
      then(({ data }) => {
        commit('setUserProfile', data.user)
      }).
      catch(handleError)
  },
}
